<div class="menu_b2c" [hidden]="Hide_menub2c() ? true : false">
  <div class="row w-100 m-0">
    <div
      class="col-sm-12 flex justify-content-center"
      style="margin-top: 10px"
      (click)="navegar()"
    >
      <div class="site-header__logo">
        <img
          [src]="logoSrc"
          alt="logo-implementos"
          title="logo-implementos"
          class="lazyload logo-implementos"
        />
      </div>
    </div>
    @if(seller){
    <div class="seller-container mt-2">
      <div
        class="seller-toggle flex align-items-center justify-content-between p-3"
        (click)="toggleSellerInfo()"
        [class.expanded]="isSellerExpanded"
      >
        <i class="pi pi-user mr-2"></i>
        <span>Vendedor</span>
        <i
          class="pi pi-chevron-down ml-2"
          [class.rotated]="isSellerExpanded"
        ></i>
      </div>

      <div class="seller-content" [class.expanded]="isSellerExpanded">
        <div class="p-3">
          <div class="seller-item flex align-items-center mb-2">
            <i class="pi pi-user"></i>
            <span>{{ seller.name }}</span>
          </div>
          <div class="seller-item flex align-items-center mb-2">
            <i class="pi pi-envelope"></i>
            <span>{{ seller.email }}</span>
          </div>
          <div class="seller-item flex align-items-center">
            <i class="pi pi-phone"></i>
            <span>{{ seller.phone }}</span>
          </div>
        </div>
      </div>
    </div>
    } @else {
    <div class="phone-info flex align-items-center justify-content-center p-3">
      <i class="pi pi-phone mr-2"></i>
      <span>Venta Telefónica {{ config.company.phone }}</span>
    </div>
    }
  </div>
</div>
<!--
<div
  class="site-header__topbar topbar"
  style="background-color: #009579; height: 15px"
></div> -->
